import { resolve } from 'aurelia';
import { IValidationController } from '@aurelia/validation-html';
import { BootstrapFormRenderer } from './bootstrap-form-renderer';
import { MouseButtonTracker } from '../browser-abstractions/mouse-button-tracker';
import { WindowAbstraction } from '../browser-abstractions/window-abstraction';

export class CustomValidationControllerFactory {
  private _mouseButtonTracker: MouseButtonTracker = resolve(MouseButtonTracker);
  private _window: WindowAbstraction = resolve(WindowAbstraction);

  // Attaches the Bootstrap renderer to a (scoped) validation controller.
  // The default trigger (blur) is configured globally via ValidationHtmlConfiguration.
  public configure(validation: IValidationController): IValidationController {
    validation.addSubscriber(new BootstrapFormRenderer(this._mouseButtonTracker, this._window));
    return validation;
  }
}
